import React from "react";
import PropTypes from "prop-types";

import Fieldset from "../../common/Fieldset";
import RadioButtonText from "../../common/RadioButtonText";
import Row from "../../common/Row";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";

import * as domainConstants from "../../../constants/DomainConstants";

const SamenwerkingForm = (props) => {
	const SAMENWERKING_TOOLTIP = "Toon de samenwerkingsverbanden aan a.d.h.v. documentatie (vb. contracten, verslagen, verklaringen…). Hier bespreek je enkel de samenwerkingsverbanden waarvan een definitieve overeenkomst of beslissing bestaat.";
	const SAMENWERKING_REALISATIE_TOOLTIP = "Omschrijf de samenwerking. Geef ook aan binnen welke termijn alle afspraken rond zullen zijn, indien dit nog niet het geval is. Motiveer ook indien er geen samenwerking inzake realisatie wordt beoogd.";
	const SAMENWERKING_EXPLOITATIE_TOOLTIP = "Omschrijf de samenwerking. Geef ook aan binnen welke termijn alle afspraken rond zullen zijn, indien dit nog niet het geval is. Motiveer ook indien er geen samenwerking inzake exploitatie wordt beoogd.";
	const SAMENWERKING_ANDER_TOOLTIP = "Omschrijf de samenwerking. Geef ook aan binnen welke termijn alle afspraken rond zullen zijn, indien dit nog niet het geval is. Motiveer ook waarom er geen andere samenwerkingsverbanden worden aangegaan.";

	const {
		beoordelingscriteria,
		disabled,
		errors,
		onChange,
		documenten,
		onDropFiles,
		onDeleteFile,
		color,
		fileTypes,
		fileSessionStarted,
		validationMessageType
	} = props;

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];

	function getFilesForDossierComponent(component) {
		if (documenten && documenten.find(x => x.name === component)) {
			return documenten.find(x => x.name === component).files;
		} else return [];
	}
	function hasFilesForDossierComponent(component) {
		if (documenten && documenten.find(x => x.name === component)) {
			const files = documenten.find(x => x.name === component).files;
			if (files) {
				return files.length > 0 ? true : false;
			}
		}
		return false;
	}

	function mapDropFiles(component) {
		return function (files) {
			onDropFiles(component, files);
		};
	}

	function mapDeleteFile(component) {
		return function (fileName) {
			onDeleteFile(component, fileName);
		};
	}

	return (
		<Fieldset title="Samenwerking">
			<RadioButtonText
				label="Zijn er samenwerkingsverbanden?"
				name="samenwerkingsVerbanden"
				value={beoordelingscriteria.samenwerkingsVerbanden}
				onChange={onChange}
				disabled={disabled}
				locked={hasFilesForDossierComponent(domainConstants.ComponentName.Samenwerkingsverbanden)}
				items={jaNee}
				horizontal
				textAreaHeight={4}
				tooltip={SAMENWERKING_TOOLTIP}
				tooltipWindowWidth={35}
				tooltipWindowAlignRight={false}
				validationMessage={errors ? errors.samenwerkingsVerbanden : ''}
				validationMessageType={validationMessageType}
				nameNee="motiveringSamenwerkingsVerbanden"
				valueNee={beoordelingscriteria.motiveringSamenwerkingsVerbanden}
				labelNee="Motivering"
				errorNee={errors ? errors.motiveringSamenwerkingsVerbanden : ''}
				maxLengthNee={2000}
			/>

			{beoordelingscriteria.samenwerkingsVerbanden == true || beoordelingscriteria.samenwerkingsVerbanden === "true" ?
				<Row>
					<RadioButtonText
						label="Zijn er samenwerkingsverbanden inzake de realisatie van het project?"
						name="inzakeDeRealisatieVanHetProject"
						value={beoordelingscriteria.inzakeDeRealisatieVanHetProject}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						textAreaHeight={4}
						tooltip={SAMENWERKING_REALISATIE_TOOLTIP}
						tooltipWindowWidth={35}
						validationMessage={errors ? errors.inzakeDeRealisatieVanHetProject : ''}
						validationMessageType={validationMessageType}
						nameJa="omschrijvingRealisatieVanHetProject"
						valueJa={beoordelingscriteria.omschrijvingRealisatieVanHetProject}
						labelJa="Omschrijving"
						errorJa={errors ? errors.omschrijvingRealisatieVanHetProject : ''}
						nameNee="motiveringRealisatieVanHetProject"
						valueNee={beoordelingscriteria.motiveringRealisatieVanHetProject}
						labelNee="Motivering"
						errorNee={errors ? errors.motiveringRealisatieVanHetProject : ''}
						maxLengthNee={2000}
						maxLengthJa={2000}
					/>
					<RadioButtonText
						label="Zijn er samenwerkingsverbanden inzake de exploitatie van het project?"
						name="inzakeDeExploitatieVanHetProject"
						value={beoordelingscriteria.inzakeDeExploitatieVanHetProject}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						textAreaHeight={4}
						tooltip={SAMENWERKING_EXPLOITATIE_TOOLTIP}
						tooltipWindowWidth={35}
						validationMessage={errors ? errors.inzakeDeExploitatieVanHetProject : ''}
						validationMessageType={validationMessageType}
						nameJa="omschrijvingExploitatieVanHetProject"
						valueJa={beoordelingscriteria.omschrijvingExploitatieVanHetProject}
						labelJa="Omschrijving"
						errorJa={errors ? errors.omschrijvingExploitatieVanHetProject : ''}
						nameNee="motiveringExploitatieVanHetProject"
						valueNee={beoordelingscriteria.motiveringExploitatieVanHetProject}
						labelNee="Motivering"
						errorNee={errors ? errors.motiveringExploitatieVanHetProject : ''}
						maxLengthNee={2000}
						maxLengthJa={2000}
					/>
					<RadioButtonText
						label="Zijn er andere samenwerkingsverbanden?"
						name="andereSamenwerkingsverbanden"
						value={beoordelingscriteria.andereSamenwerkingsverbanden}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						textAreaHeight={4}
						tooltip={SAMENWERKING_ANDER_TOOLTIP}
						tooltipWindowWidth={35}
						tooltipWindowAlignRight={false}
						validationMessage={errors ? errors.andereSamenwerkingsverbanden : ''}
						validationMessageType={validationMessageType}
						nameJa="omschrijvingAndereSamenwerkingsverbanden"
						valueJa={beoordelingscriteria.omschrijvingAndereSamenwerkingsverbanden}
						labelJa="omschrijving van de andere samenwerking"
						errorJa={errors ? errors.omschrijvingAndereSamenwerkingsverbanden : ''}
						nameNee="motiveringAndereSamenwerkingsverbanden"
						valueNee={beoordelingscriteria.motiveringAndereSamenwerkingsverbanden}
						labelNee="Motivering"
						errorNee={errors ? errors.motiveringAndereSamenwerkingsverbanden : ''}
						maxLengthJa={2000}
						maxLengthNee={2000}
					/>

					<DownloadUploadFiles
						dossierId={beoordelingscriteria.dossierId}
						title="Samenwerkingsverbanden"
						center
						disabled={disabled}
						color={color}
						tab={domainConstants.DocumentTab.Criteria}
						component={domainConstants.ComponentName.Samenwerkingsverbanden}
						onDelete={mapDeleteFile(domainConstants.ComponentName.Samenwerkingsverbanden)}
						onDrop={mapDropFiles(domainConstants.ComponentName.Samenwerkingsverbanden)}
						files={getFilesForDossierComponent(domainConstants.ComponentName.Samenwerkingsverbanden)}
						fileTypes={fileTypes.Samenwerkingsverbanden}
						validationMessage={errors ? errors.ulSamenwerkingsverbanden : ''}
						validationMessageType={validationMessageType}
						fileSessionStarted={fileSessionStarted} />
				</Row>
				: ""}
		</Fieldset>
	);
};

// ----------------------------------------------------------------------------
SamenwerkingForm.propTypes = {
	beoordelingscriteria: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	color: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	documenten: PropTypes.array,
	onDropFiles: PropTypes.func.isRequired,
	onDeleteFile: PropTypes.func.isRequired,
	fileTypes: PropTypes.object.isRequired,
	fileSessionStarted: PropTypes.bool,
	validationMessageType: PropTypes.string
};

export default SamenwerkingForm;
